import React from 'react';
import { IIconProps } from './utils';

export const ArrowRight = ({
  fill = 'currentColor', height = 21, width = 21, ...rest
}: IIconProps) => (
  <svg
    fill="none"
    height={height}
    viewBox="0 0 16 16"
    width={width}
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M13.3337 8.00001H2.66699M9.33366 12L13.3337 8.00001L9.33366 4.00001"
      stroke={fill}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.50758"
    />
  </svg>
);
